import { DocumentCard, Faq } from 'sections/Resources/FreightTemplates/DangerousGoodsDeclaration/types';

export const documentsCardData: DocumentCard[] = [
  {
    id: 1,
    iconName: 'icon-files.svg',
    heading: 'Certificate of Origin',
    url: '/resources/freight-templates/certificate-of-origin',
    fileName: 'certificate_of_origin',
  },
  {
    id: 2,
    iconName: 'icon-files.svg',
    heading: 'Packing List',
    url: '/resources/freight-templates/packing-list',
    fileName: 'packing_list',
  },
  {
    id: 3,
    iconName: 'icon-files.svg',
    heading: 'Commercial Invoice',
    url: '/resources/freight-templates/commercial-invoice',
    fileName: 'commercial_invoice',
  },
];

export const faq: Faq[] = [
  {
    id: "1",
    question: "Can a freight forwarder sign the DGD for me?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Technically, they can, but most experienced forwarders will refuse, and for good reason. The declaration is a legal certification that the goods have been packed and inspected correctly. That responsibility lies solely with the actual shipper or the certified packager. Taking on that liability is too risky for a forwarder.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "What happens if I declare it wrong?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          The best-case scenario is that the airline rejects the cargo, and you get hit with a "rejection fee" and a delay. The worst-case situation could be heavy fines from civil aviation authorities or maritime agencies, and potential legal action if an incident occurs.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "Is the Dangerous Goods paperwork interchangeable between air and ocean freight?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          No. Air freight uses the "Shipper's Declaration for Dangerous Goods" (IATA format), which is very strict (red hatchings on the side). Ocean freight uses the "IMO Dangerous Goods Declaration," which allows for slightly different formats."
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "Do I need a DGD for lithium batteries?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Almost always. Even small batteries often require a declaration or a specific compliance label, depending on the watt-hours and whether they are contained in equipment."
        </p>
      `
    ),
  },
];